import { render, staticRenderFns } from "./certificateList.vue?vue&type=template&id=2fc947c1&"
import script from "./certificateList.vue?vue&type=script&lang=js&"
export * from "./certificateList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports